<div class="d-flex align-items-center menu-title">
  <h5 class="offcanvas-title">Menu</h5>
  <div
    type="button"
    class="icon-button ml-auto"
    aria-label="Close"
    (click)="activeOffcanvas.dismiss('Cross click')"
  >
    <app-icon
      [icon]="'CLOSE'"
      [color]="'#011E3D'"
    ></app-icon>
  </div>
</div>
<div class="offcanvas-body">
  <ul class="list-unstyled">
    @for (menu of menus; track $index) {
    <app-menu-item
      [menu]="menu"
      [toggleSubMenu]="toggleSubMenu"
    ></app-menu-item>
    }
  </ul>
</div>
